import React, { Component, PropTypes } from 'react';
import { Menu, Button, Modal, Spin, Select, Radio, DatePicker, Alert, Input, Form, InputNumber, Upload, Icon } from 'antd';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import { getBase64, stripBase64FileType } from 'utils/getBase64Img';
// import ClassSchedulesTab from './ClassSchedules';
// import ClassReviewsTab from './ClassReviews';

import { connect } from 'react-redux';

import { getOrderById, editOrderById, approveOrder, cancelOrder, refundOrder } from 'data/order';
import Utils from 'utils/utils';
import { formItemLayout } from 'constants/layout';
import Dropzone from 'react-dropzone';

import OrderInfoHeader from './OrderInfoHeader';
import OrderDetail from './OrderDetail';

import classes from '../styles/order/OrderInfo.module.scss';

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;

const { TextArea } = Input;
const Confirm = Modal.confirm;

const TABS = [{ label: 'Info', value: 'info' }];

class OrderInfo extends Component {
  constructor(props) {
    super(props);
    this.onChangeFocusTab = this.onChangeFocusTab.bind(this);

    // props.getAutocompleteTeachers(props.classroom.owner.displayName);
    if (browserHistory) {
      this.backListener = browserHistory.listen((location) => {
        if (location.action === 'POP') {
          this.setState({ selectedTab: location.query.selectedTab ? location.query.selectedTab : 'info' });
        }
      });
    }

    this.state = {
      collapseMobile: [],
      mode: 'editor',
      isShowEditPaymentModal: false,
      selectedTab: props.location.query.selectedTab ? props.location.query.selectedTab : 'info',
      loading: false,
      order: {},
    };
  }

  componentDidMount = async () => {
    const orderId = this.props.params.orderId;

    const order = await getOrderById(orderId);
    this.setState({ order });
  };

  componentWillUnmount() {
    this.backListener();
  }

  getOrderById = async (orderId) => {
    const order = await getOrderById(orderId);
    this.setState({ order });
  };

  onChangeFocusTab(tab) {
    this.setState({ selectedTab: tab.key });
    browserHistory.push(`${this.props.location.pathname}?selectedTab=${tab.key}`);
  }
  onApproveOrder = () => {
    const id = this.state.order._id;
    this.setState({ loading: true });
    approveOrder(id).then(() => {
      this.getOrderById(id);
      this.setState({ loading: false });
    });
  };

  onCancelOrder = () => {
    const id = this.state.order._id;
    this.setState({ loading: true });
    cancelOrder(id).then(() => {
      this.getOrderById(id);
      this.setState({ loading: false });
      // this.getOrders(this.getCurrentQuery()).then(_.noop);
    });
  };

  handleSubmit = () => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const newOrder = { remark: values.remark };
        this.setState({ loading: true });
        editOrderById(_.get(this.state, 'order._id'), newOrder).then(() => {
          this.getOrderById(_.get(this.state, 'order._id'));
          this.setState({
            isShowRemarkModal: false,
            loading: false,
          });
        });

        console.log('Received values of form: ', values);
      }
    });
  };
  handleSubmitPaymentDetail = () => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const newOrder = {
          paymentDetail: _.merge(
            { ...this.state.order.paymentDetail },
            {
              money: values.paidMoney,
              dateTime: values.paymentDatetime.toDate(),
            },
          ),
          evidence: stripBase64FileType(this.state.uploadedImageUrl),
        };
        this.setState({ loading: true });
        editOrderById(_.get(this.state, 'order._id'), newOrder).then(() => {
          this.getOrderById(_.get(this.state, 'order._id'));
          this.setState({
            isShowEditPaymentModal: false,
            loading: false,
          });
          // browserHistory.push('/order');
        });

        console.log('Received values of form: ', values);
      }
    });
  };

  showRefundConfirm = () => {
    Confirm({
      title: 'Do you want to reject?',
      // content: content || '',
      onOk: () => {
        const id = this.state.order._id;
        refundOrder(id).then(() => {
          this.getOrderById(id);
          // this.getOrders(this.getCurrentQuery()).then(_.noop);
        });
      },
      // onCancel: this.onCancel,
    });
  };

  showCancelConfirm = () => {
    Confirm({
      title: 'Do you want to reject?',
      // content: content || '',
      onOk: () => {
        this.onCancelOrder();
      },
      // onCancel: this.onCancel,
    });
  };

  handleUploadImage = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) =>
        this.setState({
          uploadedImageUrl: imageUrl,
          loading: false,
        }),
      );
    }
  };
  beforeUpload() {}

  renderEditRemarkModal() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Modal
        title={'Edit Remark'}
        visible={this.state.isShowRemarkModal}
        onCancel={() => this.setState({ isShowRemarkModal: false })}
        footer={[
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmit}>
            Save
          </Button>,
          <Button key="back" size="large" onClick={this.props.handleCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Remark" hasFeedback>
            {getFieldDecorator('remark', {
              initialValue: this.state.order.remark,
            })(<TextArea />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderEditPaymentModal() {
    const { getFieldDecorator } = this.props.form;
    const imageUrl = this.state.uploadedImageUrl ? this.state.uploadedImageUrl : _.get(this.state, 'order.paymentDetail.evidence');

    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <Modal
        title={'Edit Payment'}
        visible={this.state.isShowEditPaymentModal}
        onCancel={() => this.setState({ isShowEditPaymentModal: false })}
        footer={[
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmitPaymentDetail}>
            Save
          </Button>,
          <Button key="back" size="large" onClick={() => this.setState({ isShowEditPaymentModal: false })}>
            Cancel
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmit}>
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={this.beforeUpload}
            onChange={this.handleUploadImage}
            customRequest={({ onSuccess }) => setTimeout(onSuccess, 1000)}
          >
            {imageUrl ? <img src={imageUrl} alt="avatar" /> : uploadButton}
          </Upload>
          <FormItem {...formItemLayout} label="Amount Paid" hasFeedback>
            {getFieldDecorator('paidMoney', {
              initialValue: _.get(this.state, 'order.paymentDetail.money'),
            })(<InputNumber />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Date & Time" hasFeedback>
            {getFieldDecorator('paymentDatetime', {
              initialValue: moment(_.get(this.state, 'order.paymentDetail.dateTime')),
            })(<DatePicker showTime format="YYYY-MM-DD HH:mm" placeholder="Select Date & Time" />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderTabs() {
    return (
      <Menu onClick={this.onChangeFocusTab} selectedKeys={[this.state.selectedTab]} mode="horizontal">
        {TABS.map((tab) => (
          <Menu.Item key={tab.value} className={classes.menuItem}>
            <div>{tab.label}</div>
          </Menu.Item>
        ))}
      </Menu>
    );
  }

  render() {
    // console.log(this.state.files);

    const { order, loading } = this.state;

    if (!order || !order.code) {
      return <div></div>;
    }

    return (
      <div>
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <div className="page-header">
            {this.props.BreadCrumb}

            <OrderInfoHeader onOpenRefundModal={() => this.showRefundConfirm()} onOpenRemarkModal={() => this.setState({ isShowRemarkModal: true })} order={this.state.order} />
          </div>
          {this.state.selectedTab === 'info' && (
            <OrderDetail
              order={this.state.order}
              openEditPaymentModal={() => this.setState({ isShowEditPaymentModal: true })}
              onApproveOrder={this.onApproveOrder}
              onCancelOrder={this.showCancelConfirm}
            />
          )}
          {this.renderEditRemarkModal()}
          {this.renderEditPaymentModal()}
        </Spin>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    // pages: state.content.pages,
  }),
  {},
)(Form.create()(OrderInfo));
